import React from "react";
import SelectInput from "common/SelectInput";
import PasswordInput from "common/PasswordInput";

const gaiiaBillingSubscribers = [
  { label: "Leave unchanged", value: "unchanged" },
  { label: "Customer ID", value: "customer-id" },
  { label: "Name", value: "name" },
  { label: "Name + Customer ID", value: "name-customer-id" },
];

const GaiiaBillingSettingsInputs = ({ onChange, defaults = {} }) => (
  <>
    <PasswordInput
      defaultValue={defaults.apikey}
      className="input-group"
      name="apikey"
      label="API key"
      onChange={onChange}
    />
    <div></div>
    <SelectInput
      label="Subscriber-ID source"
      name="subscriberIdSource"
      className="input-group"
      onChange={onChange}
      defaultValue={defaults.subscriberIdSource || "unchanged"}
      options={gaiiaBillingSubscribers}
    />
  </>
);

export default GaiiaBillingSettingsInputs;
